import { Outlet, Link, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useEffect } from "react";

// Pages that already are the request flow, or are not for creators, carry no sticky request button.
const NO_STICKY = ["/start", "/contact", "/attorneys", "/admin"];

export default function Layout() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { el.scrollIntoView({ behavior: "instant" }); return; }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  const sticky = !NO_STICKY.some((p) => pathname.startsWith(p));

  return (
    <div className={`App min-h-screen flex flex-col ${sticky ? "pb-20 sm:pb-0" : ""}`} data-testid="app-root">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {sticky && (
        <div className="fixed bottom-0 inset-x-0 sm:hidden z-40 border-t border-[#272B36] bg-[#0B0C10]/95 backdrop-blur px-4 py-3">
          <Link
            to="/start"
            data-testid="mobile-sticky-cta"
            className="block text-center bg-[#D9B36C] text-[#0B0C10] font-semibold rounded-full py-3"
          >
            Start a request
          </Link>
        </div>
      )}
    </div>
  );
}
